/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * @desc 验证邮箱
 */
import { defaultSuccess, defaultError, http } from "@/plugins/axios";

export class VerifyEmailParams {
  constructor(public code: string) {}
}

export default async function (
  params: VerifyEmailParams,
  success: ({
    data,
    ext,
    state,
    errors,
  }: {
    data: boolean;
    ext: ObjectMap;
    state: "SUCCESS" | "FAIL" | "EXCEPTION";
    errors?: Array<string>;
  }) => void = defaultSuccess,
  fail: (error: string) => void = defaultError
): Promise<void> {
  return http({
    method: "get",
    url: `/member/email-verification`,

    params,
  })
    .then((data) => success(data as any))
    .catch((error) => fail(error));
}
